import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { playNotify } from "../lib/notifySound";

export function TeknisiNotifier() {
  const { user: me } = useAuth();
  const nav = useNavigate();
  const since = useRef("");
  const isAdmin = ["admin", "admin_fasnet"].includes(me?.role);
  useEffect(() => {
    if (!isAdmin) return undefined;
    const poll = () => api.get("/teknisi/events", { params: { since: since.current } }).then((r) => {
      const d = r.data;
      if (since.current) {
        const items = [...d.messages.map((m) => ({ k: `m${m.id}`, title: `💬 Teknisi ${m.name}`, body: m.text?.slice(0, 80) })), ...(d.group || []).map((m) => ({ k: `g${m.id}`, title: `👥 Group Teknisi — ${m.name}`, body: m.text?.slice(0, 80) })), ...d.reports.filter((x) => x.status === "tertunda").map((x) => ({ k: `r${x.id}`, title: `⚠️ Laporan TERTUNDA — ${x.tech_name}`, body: `${x.type}: ${x.customer}` }))];
        if (items.length) { playNotify(); items.slice(0, 3).forEach((it) => toast(it.title, { description: it.body, action: { label: "Buka", onClick: () => nav("/laporan-teknisi") }, duration: 8000 })); }
      }
      since.current = d.now;
    }).catch(() => {});
    poll(); const t = setInterval(poll, 30000); return () => clearInterval(t);
  }, [isAdmin, nav]);
  return null;
}
